module.exports = __webpack_public_path__ + "media/images/landing_page/2023/home_main2_old-1006b35d0eec76bb62ba3e5755e1c34b.webp";